<template>
  <div class="introduce-container">
    <div class="desc_wrap">
      <span class="media_font_size_50"
        >{{ $t("information.introduce1") }}</span>
      <span class="media_font_size_50"
        >{{ $t("information.introduce2") }}</span>
      <span class="media_font_size_50"
        >{{ $t("information.introduce3") }}</span>
        <span class="media_font_size_50"
        >{{ $t("information.introduce4") }}</span>
    </div>
    <div class="img_wrap">
      <div v-for="(item, index) in imgList" :key="index">
        <div class="wrap_top">
          <div class="lf_wrap">
            <img :src="item.icon" alt />
            <div class="flex-container">
              <span>{{ item.title }}</span>
              <!-- <span>{{ item.en }}</span> -->
            </div>
          </div>
          <div class="rt_wrap">
            <span>{{ item.desc }}</span>
            <!-- <span>{{ item.desc_en }}</span> -->
          </div>
        </div>
        <img :src="item.imgUrl" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          icon: require("../../../assets/img/introduce/bt_2.png"),
          title: `${this.$t('public.exhibitionDate')}:`,
          desc: `${this.$t('public.openDate')}`,
          imgUrl: require("../../../assets/img/introduce/bg_1.jpg"),
          en: "Date:",
          desc_en: "November 15-24, 2024",
        },
        {
          icon: require("../../../assets/img/introduce/bt_1.png"),
          title: `${this.$t('public.venue')}:`,
          desc: `${this.$t('public.exhibitionVenue')}`,
          imgUrl: require("../../../assets/img/introduce/bg_2.jpg"),
          en: " Venue:",
          desc_en: "China Import and Export Fair Complex（Canton Fair Complex）",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.introduce-container {
  width: 100%;
  .desc_wrap {
    display: flex;
    flex-direction: column;
    margin-bottom: 139px;
    > span {
      text-indent: 48px;
      font-size: 24px;
      color: #fff;
      line-height: 50px;
    }
  }
  .img_wrap {
    display: flex;
    overflow: hidden;
    justify-content: space-between;
    align-items: center;
    > div {
      .wrap_top {
        display: flex;
        align-items: center;
        margin-bottom: 31px;
        .lf_wrap {
          color: #009cff;
          margin-right: 10px;
          display: flex;
          align-items: center;
          img {
            width: 40px;
            height: 40px;
            margin-right: 10px;
          }
          > span {
            font-size: 24px;
          }
          > div {
            > span {
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
        .rt_wrap {
          display: flex;
          flex-direction: column;
          > span {
            font-size: 14px;
            color: #fff;
            line-height: 20px;
          }
        }
      }
      > img {
        width: 585px;
        height: 304px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .introduce-container {
    .desc_wrap {
      > span {
        line-height: 120px;
        text-indent: 96px;
      }
    }
    .img_wrap {
      .wrap_top {
        flex-direction: column;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// introduce.vue?04b7c693